import React, { useEffect, useState } from "react";
import { FaLeftLong } from "react-icons/fa6";
import Spinner from "./elements/Spinner";

const Hero = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const iframe = document.getElementById("aparat-video");
    if (iframe) {
      iframe.addEventListener("load", () => setLoading(false));
      return () => iframe.removeEventListener("load", () => setLoading(false));
    }
  }, []);
  return (
    <div>
      <section
        className="relative  bg-cover bg-center h-auto text-white bg-bgBlue  flex max-md:flex-col max-md:items-center justify-between pt-20 pb-20 max-md:pt-10 max-md:pb-10"
        style={{ backgroundImage: "url('https://example.com/hero-image.jpg')" }}
      >
        <div className="px-6 max-w-5xl  mx-auto flex max-md:flex-col gap-4 justify-between w-full">
          <div className=" self-center flex flex-col justify-evenly h-full">
            <div className="  flex flex-col justify-center font-bold ">
              <span className=" text-xl text-white  self-start  leading-normal text-right max-md:text-center max-md:mx-auto">
                برای داشتن <br />
                کیفیت زندگی بهتر و عمر طولانی تر
              </span>
            </div>
            <div className="text-lg bg-white text-bgBlue px-4  py-2 w-fit rounded-lg flex items-center gap-2 cursor-pointer group mt-8 max-md:mx-auto font-bold">
              <p className=" whitespace-nowrap">
                آشنایی با مفهوم لانجویتی (طول عمر)
              </p>
              <FaLeftLong className="  group-hover:-translate-x-1 transition ease-out 0.3s  max-md:-rotate-90 max-md:group-hover:translate-y-1 max-md:group-hover:-translate-x-0 z-20" />
            </div>
          </div>
          <div className="max-md:w-full  flex-grow relative">
            {loading && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
                </div>
              </div>
            )}

            <div className="h_iframe-aparat_embed_frame">
              <span style={{ display: "block", paddingTop: "57%" }}></span>
              <iframe
                id="aparat-video"
                title="desc"
                src="https://www.aparat.com/video/video/embed/videohash/plkxc69/vt/frame?titleShow=true"
                allowFullScreen
                webkitAllowFullScreen
                mozAllowFullScreen
                className=" rounded-lg"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <div className="  text-xl   text-bgBlue    flex items-center   group text-center  mx-auto font-extrabold pt-12 mt-6 pb-4">
        <span className=" mx-auto">
          حفظ و ارتقای سلامت = بهترین سرمایه‌گذاری{" "}
        </span>
      </div>
    </div>
  );
};

export default Hero;
